import Joi from 'joi';

/**
 * Schema for minimum rental policy config validation
 */
export const minimumRentalConfigSchema = () =>
	Joi.object({
		minimumDays: Joi.number().min(0).integer().allow(null).optional(),
		minimumHours: Joi.number().min(0).integer().allow(null).optional(),
	})
		.unknown(false)
		.custom((value, helpers) => {
			if (value.minimumDays == null && value.minimumHours == null) {
				return helpers.error('any.custom', {
					message:
						'Provide minimumDays and/or minimumHours for minimum rental policy',
				});
			}

			return value;
		});
